<app-page-template
  *ngIf="!isShowAlertSetting"
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  [titleClass]="'tw-dir-rtl'"
  (sortObject)="getSortItems($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowHelpPage)="onShowHelpPage()"
>
  <!--------------------------------------- value of purchase btns ---------------------------------------->
  <div
    class="card-toolbar"
    before-btns
    *ngIf="currentUserInfo.organizationId == 1"
  >
    <app-periodic-date-picker
      class="!tw-bg-transparent mt-2 mx-2 row tw-mb-[-4px]"
      [config]="periodicDateConfig"
      (startDate)="setDateTime($event, 'startDate')"
      (endDate)="setDateTime($event, 'endDate')"
    >
    </app-periodic-date-picker>

    <!-- alert setting btn -->
    <button
      (click)="onSearch()"
      class="btn btn-hover-rise btn-primary button-shadow tw-mx-1 txt-lg"
      type="button"
      mat-ripple
      [matTooltip]="'common.search' | translate"
    >
      <i class="mdi mdi-magnify mdi-20px tw-p-0 tw-text-white"></i>
    </button>

    <!-- alert setting btn -->
    <button
      (click)="onAlertSetting()"
      class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
      type="button"
      mat-ripple
      [matTooltip]="'common.alertSetting' | translate"
    >
      <i class="mdi mdi-bell mdi-20px tw-p-0 text-info"></i>
    </button>
    
  </div>

  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="(items$ | async) && !pageConfig.loading">
    <ng-container *ngFor="let item of items$ | async; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
      >
        <!-- index -->
        <td class="tw-text-center !tw-p-4">
          {{ paginationModel?.firstIndex + i }}
        </td>

        <!-- strategyTitle -->
        <td>
          <td-value copyToClipboard [value]="item?.strategyTitle"></td-value>
        </td>

        <!-- UserName -->
        <td>
          <td-value copyToClipboard [value]="item?.userName"></td-value>
        </td>

        <!-- OrganizationName -->
        <td>
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>

        <!-- totalUsedCredit -->
        <td>
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.totalUsedCredit"
          ></td-value>
        </td>

        <!-- realUsedCredit -->
        <td>
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.realUsedCredit"
          ></td-value>
        </td>

        <!-- totalSentCount -->
        <td>
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.totalSentCount"
          ></td-value>
        </td>

        <!-- realSentCount -->
        <td>
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.realSentCount"
          ></td-value>
        </td>

        <!-- totalSentParts -->
        <td>
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.totalSentParts"
          ></td-value>
        </td>

        <!-- realSentParts -->
        <td>
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.realSentParts"
          ></td-value>
        </td>

        <!-- usedCreditPerEachFrequency -->
        <td>
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.usedCreditPerEachFrequency | checkValue"
          ></td-value>
        </td>

        <!-- sendSmsFrequency -->
        <td>
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.sendSmsFrequency | checkValue"
          ></td-value>
        </td>

        <!-- RecentSendDifferenceWithFrequencyStatus -->
        <td>
          <span
            [matTooltip]="
              item?.recentSendDifferenceWithFrequencyStatus
                | enumToText : RecentSendDifferenceWithFrequencyStatusEnumValues
            "
          >
            <i
              [frequencyStatusStyle]="
                item?.recentSendDifferenceWithFrequencyStatus
              "
            ></i>
          </span>
        </td>

        <td>
          <td-value
            type="number"
            copyToClipboard
            [value]="item?.totalPoint"
          ></td-value>
        </td>

        <td>
          <app-expand-item
            *ngIf="item?.points?.length > 1"
            [isCustom]="true"
            [placement]="'right'"
          >
            <ul class="custom dir-rtl tw-mb-0">
              <li *ngFor="let item of item?.points" class="tw-mb-1">
                {{
                  item?.index | enumToText : UserValueOfPurchaseIndexEnumValues
                }}:
                {{ item.point }}
              </li>
            </ul>
          </app-expand-item>

          <td-value
            *ngIf="item?.points?.length < 2"
            copyToClipboard
            type="number"
            [value]="item?.points[0].point"
          >
          </td-value>
        </td>

        <!-- recentSendSms -->
        <td>
          <td-value type="dateTime" [value]="item?.recentSendSms"></td-value>
        </td>
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>
<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>

<!--alert setting-->
<ng-container *ngIf="isShowAlertSetting">
  <app-value-of-purchase-alert-setting-form
    [model]="alertSettingData"
    (closeFormPage)="isShowAlertSetting = false; getFormResponse($event)"
  >
  </app-value-of-purchase-alert-setting-form>
</ng-container>
